import { createSelector } from 'reselect'
import { parseQuery } from '@calendly/http-tools'

import { anyEquals } from 'utils/strings'

export const isEmbeddedSelector = ({ gdpr }) => Boolean(gdpr.isEmbedded)

export const isInlineEmbedSelector = createSelector(
  isEmbeddedSelector,
  (isEmbedded) => isEmbedded && anyEquals('inline')(parseQuery(window.location.search).embed_type)
)
